<script lang="ts">
  import { createContext } from 'reka-ui'

  export type GenericButtonParentType = 'none' | 'dropdownMenu'

  export const [_useGenericButton, provideGenericButton] = createContext<{
    /** The type of the parent component. */
    isOfParentType: GenericButtonParentType
  }>('gs-generic-button')

  export function useGenericButton() {
    try {
      return _useGenericButton()
    } catch (error) {
      return {
        isOfParentType: 'none'
      }
    }
  }
</script>

<script setup lang="ts">
  const props = defineProps<{
    /** The type of the parent component. */
    isOfParentType: GenericButtonParentType
  }>()

  provideGenericButton({
    isOfParentType: props.isOfParentType
  })
</script>

<template>
  <slot />
</template>
